// @ts-nocheck
import React, { FC } from "react";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import constants from "@store/constants";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import WaveWrapperComponent from "@store/Library/Components/WaveWrapper";

const enum fields {
    hasTopWave = "hasTopWave",
    hasBottomWave = "hasBottomWave",
    bottomWaveColor = "bottomWaveColor",
}

export interface WaveWrapperProps extends WidgetProps {
    id: string;
    fields: {
        [fields.hasTopWave]: boolean;
        [fields.hasBottomWave]: boolean;
        [fields.bottomWaveColor]: string;
    };
}

const WaveWrapper: FC<WaveWrapperProps> = ({ id, fields }) => {
    const { hasTopWave, hasBottomWave, bottomWaveColor } = fields;

    return (
        <WaveWrapperComponent
            id={id}
            hasTopWave={hasTopWave}
            hasBottomWave={hasBottomWave}
            waveColor={bottomWaveColor}
        />
    );
};
const widgetModule: WidgetModule<Toolkit.FieldDefinition> = {
    component: WaveWrapper,
    definition: {
        group: constants.widgetGroup.layout,
        displayName: "Wave Wrapper",
        icon: "table-layout",
        fieldDefinitions: [
            {
                name: fields.hasTopWave,
                displayName: "Show Top Wave",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.hasBottomWave,
                displayName: "Show Bottom Wave",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
                sortOrder: 3,
            },
            {
                name: fields.bottomWaveColor,
                displayName: "Bottom Wave Color",
                editorTemplate: "CustomColorPickerField",
                defaultValue: "",
                fieldType: "General",
                sortOrder: 3,
                isVisible: widget => widget.fields.hasBottomWave,
            },
        ],
    },
};
export default widgetModule;
